/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Toggle_Caption_LockInputs */



/**
* | output |
* | --- |
* | "Toggle caption lock on/off" |
*
* @param {Shortcut_Keys_Desc_Toggle_Caption_LockInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_toggle_caption_lock = /** @type {((inputs?: Shortcut_Keys_Desc_Toggle_Caption_LockInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Toggle_Caption_LockInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer le verrouillage des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelsperre ein-/ausschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva il blocco dei sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включение/выключение блокировки субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar o desactivar el bloqueo de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换字幕锁定开/关")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションロックのオン/オフを切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन लॉक चालू/बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar/desativar o bloqueio de legendas")
	return /** @type {LocalizedString} */ ("Toggle caption lock on/off")
});